import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import "react-notifications/lib/notifications.css";
import React from "react";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { ThemeProvider } from "./context/ThemeContext";
import { useTheme } from "./context/ThemeContext";
import { lightTheme, darkTheme } from "./theme/theme";

import {
  BrowserRouter as Router,
  HashRouter,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./context/ProtectedLayout";
import ClientRoutes from "./Pages/client/ClientRoutes";
import AdminRoutes from "./Pages/admin/AdminRoutes";
import Login from "./Pages/auth/Login";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import ProtectedRouteAdmin from "./context/ProtectedLayoutAdmin";
import UserLogin from "./Pages/adminAuth/UserLogin";

const AppContent = ({ children }) => {
  const { theme } = useTheme();
  const currentTheme = theme === "light" ? lightTheme : darkTheme;

  return <MUIThemeProvider theme={currentTheme}>{children}</MUIThemeProvider>;
};

function App() {
  const { isAuthenticated, userRole, journalid } = useAuth();
  console.log(journalid);

  return (
    <ThemeProvider>
      <AppContent>
        <NotificationContainer />
        <Router>
          <Routes>
            {!isAuthenticated && (
              <Route path="/auth/login" element={<Login />} />
            )}

            <Route
              path="/admin/auth/login"
              element={
                !isAuthenticated ? (
                  <UserLogin />
                ) : userRole === "admin" ? (
                  <Navigate to="/admin/client-articles" />
                ) : (
                  <Navigate to="/admin/articles" />
                )
              }
            />

            {/* Protected Routes for Clients */}
            <Route element={<ProtectedRoute allowedRoles={["client"]} />}>
              <Route path="/client/*" element={<ClientRoutes />} />
            </Route>

            {/* Protected Routes for Admin */}
            <Route
              element={
                <ProtectedRouteAdmin allowedRoles={["admin", "user", "tl"]} />
              }
            >
              <Route path="/admin/*" element={<AdminRoutes />} />
            </Route>

            {/* Add other routes and a fallback for unauthorized */}
            <Route
              path="/unauthorized"
              element={<h1>Unauthorized Access</h1>}
            />

            {/*  */}
            <Route
              path="/"
              element={
                <Navigate
                  to={
                    isAuthenticated
                      ? userRole?.includes("admin")
                        ? "/admin"
                        : userRole?.includes("user")
                        ? "/admin"
                        : userRole?.includes("tl")
                        ? "/admin"
                        : "/client"
                      : "/auth/login"
                  }
                />
              }
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </AppContent>
    </ThemeProvider>
  );
}

export default App;
